
<v-img
    v-if="imageX"
    :src="imageX"
    :max-height="fill ? undefined : maxHeight"
    :height="fill ? '100%' : undefined"
    :aspect-ratio="fill ? undefined : 1.0"
    :contain="image"
>
</v-img>
